export default __webpack_public_path__ + "static/media/cemp-progress-img.0428fc48.png";